import { APIResponse, APIResponseDtoImpl } from '../apiresponse';

export interface LoginResponse extends APIResponse {
    getRefreshToken(): string;   
    getAccessToken(): string;  
}

export class LoginResponseDtoImpl extends APIResponseDtoImpl implements LoginResponse {
    private refreshToken: string;
    private accessToken: string;

    getRefreshToken(): string
    {
        return this.refreshToken;
    }
    setRefreshToken(refreshToken: string)
    {
        this.refreshToken = refreshToken;
    }

    getAccessToken(): string
    {
        return this.accessToken;
    }
    setAccessToken(accessToken: string)
    {
        this.accessToken = accessToken;
    }

}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/login/loginresponse.tsx